module.exports = __webpack_public_path__ + "static/media/electronics1.a53b2b26.jpg";